/* Unread-notification count for the bell badge: proactive unread alerts +
   pending bid-award notifications (the existing ingestion flow, reused).
   Polls every 60s, plus on route change so the badge reconciles right
   after the user dismisses items on /notifications. Non-critical chrome —
   any failure just leaves the count at 0. Shared by the desktop Sidebar
   bell and the mobile top bar. */

import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/MsalBootstrap';
import { getInboxCount, getPendingBidNotifications } from '@/api/notifications';
import { getPendingProposalsCount } from '@/api/proposals';

export function useUnreadCount(): number {
  const { user: authUser, getAccessToken } = useAuth();
  const location = useLocation();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let cancelled = false;
    async function loadCount() {
      if (!authUser?.oid) {
        setUnread(0);
        return;
      }
      try {
        const token = await getAccessToken();
        const [proactive, bidRows, proposals] = await Promise.all([
          getInboxCount(token),
          getPendingBidNotifications(token).catch(() => []),
          getPendingProposalsCount(token).catch(() => 0),
        ]);
        if (!cancelled) setUnread(proactive + bidRows.length + proposals);
      } catch {
        if (!cancelled) setUnread(0);
      }
    }
    void loadCount();
    const handle = setInterval(() => void loadCount(), 60000);
    return () => {
      cancelled = true;
      clearInterval(handle);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser?.oid, location.pathname]);

  return unread;
}
